/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Color_By_SpeedInputs */

const en_ui_color_by_speed = /** @type {(inputs: Ui_Color_By_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speed`)
};

const de_ui_color_by_speed = /** @type {(inputs: Ui_Color_By_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschwindigkeit`)
};

/**
* | output |
* | --- |
* | "Speed" |
*
* @param {Ui_Color_By_SpeedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_color_by_speed = /** @type {((inputs?: Ui_Color_By_SpeedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Color_By_SpeedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_color_by_speed(inputs)
	return de_ui_color_by_speed(inputs)
});